export default __webpack_public_path__ + "static/media/Maharaja05.1078d220.jpg";